import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import { registerIcons } from "@fluentui/react/lib/Styling";
import { Send28Filled } from "@fluentui/react-icons";

import "./index.css";

import Layout from "./pages/layout/Layout";
import Chat from "./pages/chat/Chat";
import Maintenance from "./pages/maintenance/Maintenance ";
import { AppStateProvider } from "./state/AppProvider";
import { CookiesProvider } from "react-cookie";

const App = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Layout />,
            children: [
                {
                    index: true,
                    element: <Chat />
                },
                {
                    path: "maintenance",
                    element: <Maintenance />
                }
            ]
        }
    ]);

    return (
        <React.StrictMode>
            <CookiesProvider>
                <AppStateProvider>
                    <RouterProvider router={router} />
                </AppStateProvider>
            </CookiesProvider>
        </React.StrictMode>
    );
};

initializeIcons();

registerIcons({
    icons: {
        Send28Filled: <Send28Filled />
    }
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
